import { $, $$ } from '../../helpers/shortcuts';
import { closeAllOverlays } from './headerOverlays';

const scrollThresholdTop = 140; // distance scrolled until wich uncollapsed header is shown
const scrollThresholdHide = 140; // distance scrolled up until header will hide again

let headerIsCollapsed = false;
let headerIsHidden = false;
let lastScrollY = 0;
let lastScrollPositionBeforeScrollDown = 0;
let lastScrollDirection = 'none';

function getElements() {
  const header = $('.header');
  const headerFirstline = $('.header-firstline');
  const menuButtonDesktop = $('.header-menubutton-desktop');
  return { header, menuButtonDesktop, headerFirstline };
}

function collapseHeader() {
  if (headerIsCollapsed) return;
  const { header } = getElements();
  header.classList.add('header-iscollapsed');
  headerIsCollapsed = true;
}

function uncollapseHeader() {
  if (!headerIsCollapsed) return;
  const { header, menuButtonDesktop } = getElements();
  header.classList.remove('header-iscollapsed');
  menuButtonDesktop.classList.add('header-menubutton-light');
  headerIsCollapsed = false;
}

function hideHeader() {
  if (document.body.hasAttribute('data-scroll-disabled')) return;
  if (headerIsHidden) return;
  const { header } = getElements();
  header.classList.add('header-ishidden');
  headerIsHidden = true;

  closeAllOverlays();
}

function showHeader() {
  if (!headerIsHidden) return;
  const { header } = getElements();
  header.classList.remove('header-ishidden');
  headerIsHidden = false;
}

function checkMenuButtonPosition() {
  const { menuButtonDesktop, headerFirstline } = getElements();
  //  Do nothing if menu button is hidden
  if (window.getComputedStyle(menuButtonDesktop).display === 'none') {
    return;
  }
  const viewportWidth = $('html').clientWidth;
  const headerContentWidth = headerFirstline.clientWidth;
  const buttonWidth = menuButtonDesktop.clientWidth;
  const gapSize = 12;
  const basePositionX =
    (viewportWidth - headerContentWidth) / 2 - buttonWidth - gapSize;
  menuButtonDesktop.style.left = `${basePositionX}px`;

  if (headerIsCollapsed && !headerIsHidden) {
    menuButtonDesktop.classList.remove('header-menubutton-light');
  } else {
    menuButtonDesktop.classList.add('header-menubutton-light');
  }
}

function checkHeaderSizing() {
  if (document.body.hasAttribute('data-scroll-disabled')) return;
  const { scrollY } = window;
  let scrollDirection = 'none';

  if (lastScrollY < scrollY) {
    scrollDirection = 'down';
  } else if (lastScrollY > scrollY) {
    scrollDirection = 'up';
  }

  const scrollDirectionChanged =
    lastScrollDirection !== scrollDirection || scrollY === 0;

  if (scrollY > scrollThresholdTop) {
    collapseHeader();
    switch (scrollDirection) {
      case 'down':
        // only hide header if scroll up has been done over a certain distance
        if (
          lastScrollPositionBeforeScrollDown !== null &&
          scrollY - lastScrollPositionBeforeScrollDown >= scrollThresholdHide
        ) {
          hideHeader();
        }
        break;
      case 'up':
        showHeader();
        break;
      default:
        showHeader();
        break;
    }
  } else {
    uncollapseHeader();
    showHeader();
  }

  checkMenuButtonPosition();

  if (scrollDirection === 'down' && scrollDirectionChanged) {
    lastScrollPositionBeforeScrollDown = scrollY;
  }

  lastScrollY = scrollY;
  lastScrollDirection = scrollDirection;
}

function initializeHeaderInputSync() {
  // sync both header input boxes so that search texts do not disappear
  const searchInputSelectors = [
    `.header-search-desktop input[type='search']`,
    `.header-search-mobile input[type='search'].header-search-input`,
  ];
  const searchInputs = $$(searchInputSelectors.join(', '));
  searchInputs.forEach((searchInput) => {
    searchInput.addEventListener('input', (e) => {
      [...searchInputs]
        .filter((otherSearchInput) => otherSearchInput !== e.target)
        .forEach(
          (otherSearchInput) => (otherSearchInput.value = e.target.value),
        );
    });
  });
}

function initializeHeader() {
  const { header } = getElements();
  if (!header) return;
  headerIsCollapsed = header.classList.contains('header-iscollapsed');

  window.addEventListener('scroll', checkHeaderSizing);
  window.addEventListener('resize', checkHeaderSizing);

  header.addEventListener('focusin', showHeader);
  header.addEventListener('focusin', uncollapseHeader);
  header.addEventListener('focusout', checkHeaderSizing);

  checkHeaderSizing();

  initializeHeaderInputSync();
}

export { initializeHeader, checkHeaderSizing };
